import React from "react";
import SpecialUnit from "./SpecialUnit";

const ControlRoom = () => <SpecialUnit speId={5} />;

export default ControlRoom;
